export default "\n  <mat-spinner diameter=\"80\" color=\"accent\" style=\"margin: auto;top:50%;margin-top: -40px;\"></mat-spinner>\n\n\n"